export type RrwebEventsSchema = {
  id: number;
  chunkId: string;
  timestamp: number;
  data: unknown;
};

export const rrwebEventsSchema = '++id, chunkId, timestamp';

export type RrwebChunksSchema = {
  id: string;
  tabId: string;
  startTime: number;
  endTime: number;
  eventCount: number;
  sizeEstimate: number;
  /** JSON-stringified RrwebNetworkCall[] */
  networkJson?: string;
  status: 'open' | 'closed';
  elapsedMs: number;
};

export const rrwebChunksSchema = '&id, tabId, startTime, [tabId+status]';
